export default __webpack_public_path__ + "static/media/three_tou2.96523207.png";